/**
 * isFirefox
 * Indicates if the browser identifies as Firefox (true) or not (false)
 *
 * Input: N/A
 * Output: boolean
 */
export const isFirefox = () =>
  window.navigator.userAgent.indexOf('Firefox') > -1;

/**
 * isHighContrastMode
 * Verifies if the browser is in high contrast mode by creating a div and
 * checking a specific color. True = HCM; False = No HCM.
 *
 * Input: N/A
 * Output: String
 */
export const isHighContrastMode = () => {
  const testDiv = document.createElement('div');
  testDiv.style.color = 'rgb(200, 100, 50)';
  document.body.appendChild(testDiv);
  const { color } = window.getComputedStyle(testDiv, null);
  document.body.removeChild(testDiv);
  if (color === 'rgb(200, 100, 50)') {
    // No change: not high contrast mode
    return '';
  }
  if (color === 'rgb(0, 0, 0)') {
    return 'hc-white';
  }
  return 'hc-other';
};

// exports
export const BrowserUtils = {
  isFirefox,
  isHighContrastMode
};
export default BrowserUtils;
